<template>
    <MainPage @clickBack="clickBack()">
        <div class=" border border-a-brown-d7c7b8 rounded-2xl mt-3.5 lg:mt-0 mx-4 lg:w-554px lg:mx-auto">
            <TabMenu @updateActiveMenu="updateActiveMenu($event)"></TabMenu>
            <Available v-if="activeList == 'available'"
                        ref="purchase_unused"
                        :listConfig="purchaseListConfig"
                        :filterConfig="purchaseFilterListConfig"
            ></Available>
            <Expired v-if="activeList == 'expired'"
                        ref="purchase_used"
                        :listConfig="purchaseListConfig"
                        :filterConfig="purchaseFilterListConfig"
            ></Expired>
            <Subscription v-if="activeList == 'subscription'"></Subscription>
        </div>
    </MainPage>
</template>

<script>
import ConfigManager from '@/config/ConfigManager.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import TabMenu from '@/module/MyCoupon/component/TabMenu.vue'
import Available from '@/module/MyCoupon/component/Available.vue';
import Expired from '@/module/MyCoupon/component/Expired.vue';
import Subscription from '../component/Subscription.vue';
//service
import {
    PurchaseListConfigBuilder,
    PurchaseFilterConfigBuilder,
} from '@/core/History/config/HistoryConfigModel.js';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
export default {
    name: 'MyCoupon',
    mixins: [ModalMixin],
    components: {
        MainPage,
        TabMenu,
        Available,
        Expired,
        Subscription
    },
    data: function() {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,

            activeList: 'available',
        }
    },
    created: function() {
        this.tracking.event('rewards','view_my_coupons',null,null);
        this.setScrollLoadMore();
        this.updateActiveMenu();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        updateActiveMenu: async function(activeMenu){
            this.activeList = activeMenu || this.activeList;
            if (this.activeList == 'available') {
                this.purchaseConfig = 'purchase_unused'
                await this.setupHistoryList();
                await this.$refs['purchase_unused'].getList();
            }
            if (this.activeList == 'expired') {
                this.purchaseConfig = 'purchase_used'
                await this.setupHistoryUsed();
                await this.$refs['purchase_used'].getList();
            }
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        setupHistoryList: async function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseUnUsed())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },
         setupHistoryUsed: async function () {
            //initial config for api.
            var listConfig = new PurchaseListConfigBuilder()
                .setConfigList(ConfigManager.getHistoryPurchaseUsed())
                .setTop(25)
                .create();
            this.purchaseListConfig = listConfig;

            //initial filter config for api.
            var filterListConfig = new PurchaseFilterConfigBuilder()
                .create();
            this.purchaseFilterListConfig = filterListConfig;
        },
        clickBack: function(){
            this.$router.back();
        },
        loadMore: async function() {
            this.modal.loadingModal.show();
            if (this.activeList == 'available') {
                await this.$refs['purchase_unused'].loadMore();
            }
            if (this.activeList == 'expired') {
                await this.$refs['purchase_used'].loadMore();
            }
            this.modal.loadingModal.hide();
        },
    },
}
</script>

<style>

</style>
